// components/ImageModal.js
import React from 'react';
import styles from '../ChatApp.module.css';

const ImageModal = ({ imageUrl, onClose }) => {
    if (!imageUrl) return null;
    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) onClose();
    };
    return (
        <div className={styles.modalOverlay} onClick={handleOverlayClick}>
            <div className={styles.modalContent}>
                <img src={imageUrl} alt="Enlarged product" className={styles.modalImage} />
            </div>
        </div>
    );
};

export default ImageModal;